import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as Template from "../../templates";
import * as actions from "../../actions";
import { useNavigate, useParams } from "react-router-dom";

export default () => {
  const moduleName = `wholesale_shippings`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const params = useParams()

  const navigate = useNavigate()

  const [id, setId] = useState();

  const [name, setName] = useState(``);
  const [min_weight, setMinWeight] = useState(``);
  const [max_weight, setMaxWeight] = useState(``);
  const [price, setPrice] = useState(``);

  const [categoryId, setCategoryId] = useState(``);
  const [categories, setCategories] = useState(``);

  const [submitted, setSubmitted] = useState(false);

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (appReducer.wholesale_shippings_edit != undefined && id != undefined) {
      let row = appReducer.wholesale_shippings_edit.data;
      setName(row.name);
      setPrice(row.price);
      setMinWeight(row.min_weight)
      setMaxWeight(row.max_weight)
      setCategoryId({
        value: row.province_id,
        label: row.province.name
      });
    }
  }, [appReducer.wholesale_shippings_edit]);

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.wholesale_shippings_store != undefined && appReducer.wholesale_shippings_store.error == false) ||
        (appReducer.wholesale_shippings_update != undefined && appReducer.wholesale_shippings_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.wholesale_shippings_store,
    appReducer.wholesale_shippings_update
  ])

  useEffect(() => {
    dispatch(actions.list(`provinces/option`));
  }, []);

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])



  useEffect(() => {
    if (appReducer.provinces_option_list != undefined) {
      setCategories(appReducer.provinces_option_list.data);
    }
  }, [appReducer.provinces_option_list]);

  const onChange = (value) => setCategoryId(value);

  return <Template.Form>
    <Template.SingleSelect
      withLabel
      required
      placeholder="انتخاب استان"
      name="province_id"
      value={categoryId}
      onChange={onChange}
      options={categories}
    />
    <Template.Input required value={name} label="نام" name="name" type="text" />
    <Template.Input required value={min_weight} label="وزن از" name="min_weight" type="number" />
    <Template.Input required value={max_weight} label="وزن تا" name="max_weight" type="text" />
    <Template.Input required value={price} label="قیمت هر واحد (تومان)" name="price" type="text" />
    <Template.Button
      label="ذخیره"

      onClick={handleClick}
    />
  </Template.Form>
};